import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from './environment.service';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
/**
 * The Servie used for Imports of Contracts
 */
@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }
  /**
   * Upload a customer File
   * @param file 
   * @returns 
   */
  uploadCustomerFile(file) {
    let data: FormData = new FormData();
    data.append('file', file);
    return this.http.post(`${this.environment.getApiUrl()}/customer/erp`, data);
  }
  /**
   * Upload a ContractFile
   * @param file 
   * @returns 
   */
  uploadContractFile(file) {
    let data: FormData = new FormData();
    data.append('file', file);
    return this.http.post(`${this.environment.getApiUrl()}/customer/contract/erp`, data);
  }
  /**
   * Get the Plausibility Check for the Import Job (Customers)
   * @param jobName 
   * @returns 
   */
  getCustomerPlausiCheck(jobName): Observable<any[]> {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get<any[]>(`${url}/customer/erp/plausiCheck/${jobName}`)
      )
    )
  }
  /**
   * Get the Plausibility Check for the Import Job (Contracts)
   * @param jobName 
   * @returns 
   */
  getContractPlausiCheck(jobName): Observable<any[]> {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get<any[]>(`${url}/customer/contract/erp/plausiCheck/${jobName}`)
      )
    )
  }
  /**
   * Start an Import Job
   * @param jobName 
   * @returns 
   */
  startImportJob(jobName) {
    return this.http.post(`${this.environment.getApiUrl()}/job/import/${jobName}`, {});
  }
}
